
import { defineComponent, PropType } from "vue";
import { AssetProps } from "../../../composables/types";

export default defineComponent({
  name: "ResponsiveImage",
  props: {
    image: {
      type: Object as PropType<AssetProps>,
      required: true,
    },
    altText: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const url = props.image?.url || "";
    const alt = props.altText || props.image?.description || "";

    return {
      url,
      alt,
    };
  },
});
